import { render, staticRenderFns } from "./txt.vue?vue&type=template&id=68c200cd&scoped=true"
import script from "./txt.vue?vue&type=script&lang=js"
export * from "./txt.vue?vue&type=script&lang=js"
import style0 from "./txt.vue?vue&type=style&index=0&id=68c200cd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c200cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c200cd')) {
      api.createRecord('68c200cd', component.options)
    } else {
      api.reload('68c200cd', component.options)
    }
    module.hot.accept("./txt.vue?vue&type=template&id=68c200cd&scoped=true", function () {
      api.rerender('68c200cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/treety/treeties/form/txt.vue"
export default component.exports